import { render } from "./loginComponent.vue?vue&type=template&id=296d2254&scoped=true"
import script from "./loginComponent.vue?vue&type=script&lang=js"
export * from "./loginComponent.vue?vue&type=script&lang=js"

import "./loginComponent.vue?vue&type=style&index=0&id=296d2254&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Agile-bot-web-dashboard/Agile-bot-web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296d2254"]])

export default __exports__